package components.burgerMenu

import common.EConstants
import common.ECssClasses
import core.enums.EImages
import core.enums.EJSBridgeActions
import core.enums.ELocalizationKeys
import core.extensions.isInNativeApp
import core.extensions.postMessageToNativeApp
import core.extensions.toClassName
import core.io.dto.ExternalLinkDTO
import core.io.dto.JSBridgeActionDTO
import core.ionic.EmptyProps
import core.ionic.IonButton
import core.ionic.IonButtons
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonGrid
import core.ionic.IonHeader
import core.ionic.IonMenu
import core.ionic.IonRow
import core.ionic.IonToolbar
import core.localization.Localization
import core.piwik.Piwik
import csstype.AlignSelf
import csstype.Display
import csstype.AlignItems
import csstype.ClassName
import csstype.Overflow
import csstype.number
import csstype.pct
import csstype.px
import emotion.react.css
import kotlinx.browser.window
import react.FC
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.hr
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.strong
import react.ref
import react.router.useNavigate
import react.useRef
import screens.EScreens

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 04.11.22
 * Author : leonhergt
 */

val BurgerMenu = FC<EmptyProps> {

    val navigate = useNavigate()
    val mMenuRef = useRef<BurgerMenuElement>(null)


    IonMenu {
        ref = mMenuRef
        contentId = EConstants.BURGER_MENU_CONTENT.mId
        IonHeader {
            className = ClassName("ion-no-border")

            IonToolbar {
                css(ECssClasses.ION_TOOLBAR_NO_BACKGROUND.toClassName()) {
                    marginLeft = 10.px
                    display = Display.flex
                    alignItems = AlignItems.center
                }
                
                div {
                    css {
                        display = Display.flex
                        alignItems = AlignItems.center
                        height = 100.pct
                    }
                    img {
                        css {
                            height = 48.px
                            width = 48.px
                        }
                        src = EImages.ALPINA_LOGO.mRelativePath
                    }
                }

                IonButtons {
                    slot = "end"
                    css {
                        marginRight = 12.px
                    }
                    IonButton {
                        fill = "clear"
                        css {
                            alignSelf = AlignSelf.center
                        }
                        img {
                            css {
                                height = 16.px
                                width = 16.px
                            }
                            src = EImages.CLOSE_ICON_GREY.mRelativePath

                        }
                        onClick = {
                            mMenuRef.current?.close()
                        }
                    }
                }


            }
        }
        IonContent {
            css {
                overflowY = Overflow.scroll
            }
            div {
                css {
                    display = Display.flex
                    flexDirection = csstype.FlexDirection.column
                    height = 100.pct
                    justifyContent = csstype.JustifyContent.spaceBetween
                }
                
                div {
                    css {
                        display = Display.flex
                        flexDirection = csstype.FlexDirection.column
                        flexGrow = number(0.0)
                        flexShrink = number(0.0)
                    }
                    IonGrid {
                        IonRow {
                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_TOP_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.COLOUR_FINDER_UPLOAD_SCREEN.mPath)
                                        Piwik.trackCustomEvent(Piwik.CATEGORY_RESTART, Piwik.NAME_RESTART_BURGER_MENU, Piwik.NAME_RESTART_BURGER_MENU)
                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_RESTART.name)
                                }
                            }
                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_TOP_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.PRODUCT_LIST_SCREEN.mPath)
                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_PRODUCTLIST.name)
                                }
                            }
                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_TOP_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.WATCH_LIST_SCREEN.mPath)
                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_WATCHLIST.name)
                                }
                            }
                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_TOP_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        if(!window.isInNativeApp()){
                                            window.open(Localization.getLocalizationKey
                                                (ELocalizationKeys.RETAIL_SEARCH_URL.name))
                                        }else{
                                            val jsBridgeActionDTO = JSBridgeActionDTO(
                                                EJSBridgeActions.EXTERNAL_LINK,
                                                ExternalLinkDTO(Localization.getLocalizationKey
                                                    (ELocalizationKeys.RETAIL_SEARCH_URL.name))
                                            )
                                            window.postMessageToNativeApp(jsBridgeActionDTO)
                                        }
                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_RETAILER_SEARCH.name)
                                }
                            }
                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_TOP_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.HOME_SCREEN.mPath)

                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_RESTART_TOUR.name)
                                }
                            }
                        }
                    }
                }
                

                div {
                    css {
                        display = Display.flex
                        flexDirection = csstype.FlexDirection.column
                        flexGrow = number(0.0)
                        flexShrink = number(0.0)
                        marginTop = 16.px
                    }
                    IonGrid {
                        IonRow {
                            IonCol {
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_LEGAL_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                size = "12"
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.IMPRINT_SCREEN.mPath)
                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_IMPRINT.name)
                                }
                            }

                            IonCol {
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_LEGAL_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                size = "12"
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.INTEGRITY_SCREEN.mPath)
                                        mMenuRef.current?.close()
                                    }
                                    div {
                                        +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_INTEGRITY.name)
                                    }
                                }
                            }

                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_LEGAL_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.PRIVACY_SCREEN.mPath)
                                        mMenuRef.current?.close()
                                    }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_PRIVACY.name)
                                }
                            }
                            IonCol {
                                size = "12"
                                css(ECssClasses.BURGER_MENU_ITEM.toClassName(), ECssClasses.BURGER_MENU_LEGAL_ITEM.toClassName(), ECssClasses.CURSOR_HOVER.toClassName()) { }
                                div {
                                    onClick = {
                                        navigate.invoke(EScreens.SETTINGS_SCREEN.mPath)
                                        mMenuRef.current?.close()
                                    }
                                    div {
                                        +Localization.getLocalizationKey(ELocalizationKeys.MENU_TITLE_SETTINGS.name)
                                    }
                                }
                            }

                            IonCol {
                                size = "12"
                                hr {
                                    css(ECssClasses.DIVIDER.toClassName()) { }
                                }
                                div {
                                    css(ECssClasses.BURGER_MENU_NOTE_TITLE.toClassName()) { }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_NOTE_COLOR_ACCURACY_TITLE.name)
                                }
                                div {
                                    css(ECssClasses.BURGER_MENU_NOTE.toClassName()) { }
                                    +Localization.getLocalizationKey(ELocalizationKeys.MENU_NOTE_COLOR_ACCURACY_TEXT.name)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

external interface BurgerMenuElement {
    fun close()
}